import { Dispatch } from 'redux';
import { change } from 'redux-form';
import { CHECKOUT_FORM_NAME } from '../constants';
import {
    EB_MARKETING_OPT_IN_FIELD,
    ORG_MARKETING_OPT_IN_FIELD,
} from '../containers/checkout/constants';
import { shouldInitializeEBMarketingOptIn } from '../selectors/marketingOptIn';
import { CheckoutState } from '../state';

export const initializeEBMarketingOptIn =
    () =>
    (dispatch: Dispatch<CheckoutState>, getState: () => CheckoutState) => {
        const state = getState();

        if (!shouldInitializeEBMarketingOptIn(state)) {
            return;
        }

        dispatch(change(CHECKOUT_FORM_NAME, EB_MARKETING_OPT_IN_FIELD, true));
        dispatch(change(CHECKOUT_FORM_NAME, ORG_MARKETING_OPT_IN_FIELD, true));
    };
